//src/app/features/questionnaires/components/QuestionnaireMainTabs/index.tsx
import { CheckedIcon, WarningIcon } from 'assets/icons';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { selectQuestionnaireRoutes } from '../../edit/routes/slice';
import styles from './QuestionnaireMainTabs.module.css';
export interface IQuestionnaireMainTabsProps {}

export default function QuestionnaireMainTabs(
  props: IQuestionnaireMainTabsProps,
) {
  const questionnaireRoutes = useSelector(selectQuestionnaireRoutes);

  return (
    <ul
      style={{ minHeight: '64px' }}
      className="flex h-16 flex-wrap list-none border-b border-gray-800 md-max:flex-nowrap md-max:overflow-x-auto no-scrollbar"
    >
      {Object.values(questionnaireRoutes.routes).map((route) => (
        <li
          key={route.path}
          className="flex-grow text-center"
          role="presentation"
        >
          <NavLink
            className={({ isActive }) =>
              isActive ? ` ${styles.tab_active}` : `${styles.tab}`
            }
            to={route.path}
          >
            <div className="flex gap-6 items-center min-w-max">
              {route.title}
              {route.isValid === true && <CheckedIcon className="w-4 h-4" />}
              {route.isValid === false && <WarningIcon className="w-4 h-4" />}
            </div>
          </NavLink>
        </li>
      ))}
    </ul>
  );
}
